import { Component, inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { Browser } from '@capacitor/browser';

@Component({
	selector: 'app-login',
	imports: [FormsModule],
	templateUrl: './login.component.html',
})
export class LoginComponent {
	router = inject(Router);
	authService = inject(AuthService);

	username = '';
	password = '';
	loginError = false;
	loading = false;
	showPassword = false;

	login() {
		if (!this.username || !this.password) return;
		this.loading = true;
		this.loginError = false;

		this.authService.login(this.username, this.password).subscribe({
			next: () => {
				this.loading = false;
				this.router.navigate(['/app/dashboard']);
			},
			error: () => {
				this.loading = false;
				this.loginError = true;
			},
		});
	}

	goToRecuperaPassword() {
		this.router.navigate(['/app/public/recupera-password']);
	}

	async loginMicrosoft() {
		await Browser.open({ url: 'https://signbookapi.kefirma.it/api/public/login-microsoft/start?platform=mobile' });
	}
}
